import { render, staticRenderFns } from "./userIntegralDetailsView.vue?vue&type=template&id=02a2173d&scoped=true"
import script from "./userIntegralDetailsView.vue?vue&type=script&lang=js"
export * from "./userIntegralDetailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a2173d",
  null
  
)

export default component.exports